import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight, Instagram } from "lucide-react";
import AboutProduct from "../components/about/AboutProduct";
import AboutCeo from "../components/about/AboutCeo";

export default function About() {
  return (
    <div className="min-h-screen bg-[#0b1120] text-slate-200">
      <header className="border-b border-slate-800/70 bg-slate-950/60 backdrop-blur sticky top-0 z-10">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-300 hover:text-white" data-testid="about-back-home">
            <ArrowLeft size={16} /> <img src="/compass-logo.png" alt="" className="w-6 h-6 object-contain" /> Compass PM
          </Link>
          <Link to="/register" className="text-sm bg-blue-600 hover:bg-blue-500 text-white px-4 py-2 rounded-lg" data-testid="about-cta-header">Start free</Link>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-6 py-16 sm:py-20" data-testid="about-main">
        <AboutProduct />
        <AboutCeo />
        <section className="mt-20 pc-card p-8 sm:p-10 text-center" data-testid="about-closing">
          <div className="text-2xl sm:text-3xl font-bold text-white" style={{ fontFamily: "Outfit" }}>
            Compass PM: Plan clearly. Deliver confidently.
          </div>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link to="/register" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 text-white px-6 py-3 rounded-xl font-semibold" data-testid="about-cta-start">
              Explore Compass PM <ArrowRight size={16} />
            </Link>
            <Link to="/contact" className="inline-flex items-center gap-2 border border-slate-700 text-slate-200 px-6 py-3 rounded-xl hover:border-blue-400/40" data-testid="about-cta-contact">Contact us</Link>
          </div>
          <a href="https://www.compasspm.app" className="block mt-4 text-sm text-blue-400 hover:text-blue-300" data-testid="about-site-link">www.compasspm.app</a>
        </section>
        <footer className="mt-16 border-t border-slate-800/70 pt-6 text-xs text-slate-500">
          © 2026 Uplift Communications Incorporated · Compass PM ·{" "}
          <Link to="/privacy" className="text-slate-400 hover:text-white" data-testid="about-privacy-link">Privacy</Link> ·{" "}
          <Link to="/contact" className="text-slate-400 hover:text-white" data-testid="about-contact-link">Contact</Link> ·{" "}
          <a href="https://www.instagram.com/compasspm.app/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-blue-400 hover:text-blue-300" data-testid="about-instagram-link"><Instagram size={12} /> Instagram</a>
        </footer>
      </main>
    </div>
  );
}
